import { CommissionApiResponse } from "../../../../services/api.service-types";
import { ProcessorType } from "../../../../types/processor.types";

export interface EditMidForm {
    processorId: string;
    midName: string,
    trashHoldLimit?: number
    midCode: string;
    midDescriptor: string;
    commissions?: CommissionFormField[];
    valid: boolean;
}

export interface CommissionFormField {
    value?: number;
    valueType: CommissionValueType;
    type: CommissionType;
}

export enum CommissionValueType {
    PERCENT = 'PERCENT',
    FIXED = 'FIXED'
}

export enum CommissionType {
    MDR = 'MDR',
    ROLLING = 'ROLLING',
    TRANSACTION = 'TRANSACTION',
    REFUND = 'REFUND',
    CHARGEBACK = 'CHARGEBACK',
    SETTLEMENT = 'SETTLEMENT',
    CHARGEBACK_ALERT = 'CHARGEBACK_ALERT',
    RDR = 'RDR'
}

export interface ProcessorData {
    id: number,
    processorType: ProcessorType,
    processorName: string;
}


export interface EditMerchantMid {  
  mid: {
    id?: string;
    processorId: string;
    merchantId: string;
    midCode: string;
    trashHoldLimit: number;
    midName: string;
    midDescriptor: string;
    valid: boolean;
  },
  commissions: Partial<CommissionApiResponse>[];
} 
